import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

const categories = [
  {
    image: "/assets/images/bag.webp",
    title: "Eco Bags",
    subtitle: "Sustainable & Stylish",
    path: "/shop/eco-bag",
    description: "Handcrafted eco-friendly bags for the conscious fashionista",
  },
  {
    image: "/assets/images/cushion.webp",
    title: "Cushion Covers",
    subtitle: "Comfort Redefined",
    path: "/shop/cushion-covers",
    description: "Luxurious cushion covers to transform your living space",
  },
  {
    image: "/assets/images/frock.webp",
    title: "Frocks",
    subtitle: "Elegant & Timeless",
    path: "/shop/frocks",
    description: "Beautiful frocks that celebrate your unique style",
  },
];

const Categories = () => {
  const router = useRouter();
  const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);

  const handleCardClick = (category: (typeof categories)[0]) => {
    router.push(category.path);
  };

  return (
    <div className="ch-luxury-categories">
      <div className="ch-luxury-categories__container">
        {categories.map((category, index) => (
          <motion.div
            key={category.title}
            className="ch-luxury-category-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => handleCardClick(category)}
          >
            {/* Background Image */}
            <div className="ch-luxury-category-card__image-container">
              <Image
                src={category.image}
                alt={category.title}
                fill
                className="ch-luxury-category-card__image"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
              <div className="ch-luxury-category-card__overlay" />
            </div>

            {/* Content */}
            <div className="ch-luxury-category-card__content">
              {/* Luxury Badge */}
              <div className="ch-luxury-category-card__badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
                <span>Premium</span>
              </div>

              {/* Title and Subtitle */}
              <div className="ch-luxury-category-card__text">
                <h3 className="ch-luxury-category-card__title">{category.title}</h3>
                <p className="ch-luxury-category-card__subtitle">{category.subtitle}</p>
                <p className="ch-luxury-category-card__description">{category.description}</p>
              </div>

              {/* CTA Button */}
              <motion.div
                className="ch-luxury-category-card__cta"
                initial={{ opacity: 0, y: 20 }}
                animate={{ 
                  opacity: hoveredIndex === index ? 1 : 0, 
                  y: hoveredIndex === index ? 0 : 20 
                }}
                transition={{ duration: 0.3 }}
              >
                <button className="ch-luxury-category-card__button">
                  <span>Explore Collection</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </motion.div>
            </div>

            {/* Decorative Elements */}
            <div className="ch-luxury-category-card__decoration">
              <div className="ch-luxury-category-card__decoration-line"></div>
              <div className="ch-luxury-category-card__decoration-dot"></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
